import React from "react";
import NoCarFound from "./component";

export default (NoCarFound);
